<template>
  <section>
    <h3 class="step-three__header">Step 3: Define what you want to annotate</h3>
    <div class="step-three__div">
      <p>Type of task:</p>
      <select
        class="step-three__select"
        :value="schemeType"
        @change="changeSchemeType"
      >
        <option value="form">Classification</option>
        <option value="segmentation">Segmentation</option>
        <option value="box">Bounding box</option>
      </select>
    </div>
    <div class="step-three__div">
      <p>Name of the variable:</p>
      <fg-input class="step-three__input" :value="schemeName" @change.native="changeSchemeName"></fg-input>
    </div>
    <div class="step-three__div">
      <p>Values (one per line):</p>
      <textarea class="step-three__textarea" :value="reformTextarea(schemeDescription)" @change="changeSchemeDescription" v-if="this.schemeType === 'form'"></textarea>
      <div v-else class="step-three__colorful-values">
        <scheme-labels></scheme-labels>
      </div>
    </div>
  </section>
</template>
<script>
  import SchemeLabels from "../SchemeLabels";
  export default {
    name: 'page-one',
    components: {
      SchemeLabels
    },
    computed: {
      schemeType() {
        return this.$store.getters.getSchemeType;
      },
      schemeName() {
        return this.$store.getters.getSchemeName;
      },
      schemeDescription() {
        return this.$store.getters.getSchemeDescription;
      }
    },
    methods: {
    changeSchemeType(e) {
      this.$store.dispatch("onTypeChange", e.target.value);
      this.$store.dispatch("changeForwardState", false);
    },
    changeSchemeName(e) {
      this.$store.dispatch("onNameChange", e.target.value);
    },
    changeSchemeDescription(e){
      this.$store.dispatch("onDescriptionChange", e.target.value);
    },
    reformTextarea(description) {
      let values = "";
      if(typeof description === "string"){
        values = description;
      } else if (Array.isArray(description)) {
        values = description.join("\n");
      } else {
        values = description.choises.join("\n");
      }

      return values;
    },
    }
  }
</script>
<style lang="scss" scoped>
.step-three {
  &__header {
    margin-top: 0px;
    margin-bottom: 10px;
  }

  &__div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 0 35px;
  }

  &__select {
    width: 50%;
    padding: 5px 0;
    border-radius: 5px;
    font-size: 18px;
    color: #817676;
    margin-bottom: 1em;

    &:focus {
      outline: none;
    }
  }

  &__input {
    width: 50%;
    border-radius: 5px;
  }

  &__textarea {
    width: 50%;
    height: 95px;
  }

  &__colorful-values {
    width: 50%;
  }
}
</style>
